export default {
  subTitle: 'Settings',
  pageTitle: 'Platform invoice',
  description: "Generate a Peoforma invoice by clicking on the button below. Choose dates and then click on 'get invoice'",

  createProfomaInvoice: 'Create a peoforma invoice'
}